import { I18n } from '@calendly/i18n';
import { BatchControls as Container } from '@calendly/table';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledContainerCss = "s1jyl7ut";
const StyledContainer = forwardRef((props, ref) => <Container ref={ref} {...props} className={classNames(styledContainerCss, props.className)} />);
export const BatchControls = ({
  selectionCount,
  onClose,
  children
}) => <StyledContainer onClose={onClose}>
    {children}
    {I18n.t('publisher.organization.members.selected_members_count', {
    count: selectionCount
  })}
  </StyledContainer>;

require("./batch_controls.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./batch_controls.js");